import {
  createContext,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from "react";

interface BrianBubbleSlot {
  content: ReactNode | null;
  show: (content: ReactNode) => void;
  hide: () => void;
}

const BrianBubbleContext = createContext<BrianBubbleSlot | null>(null);

export const BrianBubbleProvider = ({ children }: { children: ReactNode }) => {
  const [content, setContent] = useState<ReactNode | null>(null);
  const value = useMemo<BrianBubbleSlot>(
    () => ({
      content,
      show: setContent,
      hide: () => setContent(null),
    }),
    [content],
  );
  return <BrianBubbleContext value={value}>{children}</BrianBubbleContext>;
};

export const useBrianBubble = (): BrianBubbleSlot => {
  const slot = useContext(BrianBubbleContext);
  if (!slot) throw new Error("useBrianBubble outside BrianBubbleProvider");
  return slot;
};
